import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// Reaproveita o layout apresentacional do DECOMP (texto + galeria de mapas) —
// mesmo contrato de dados (IntersemanalChuva é estruturalmente igual a DecompChuva),
// sem necessidade de duplicar o componente.
import ChuvaLayout from 'components/Relatorios/Decomp/ChuvaLayout';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useIntersemanalSecaoParams from 'hooks/Relatorios/Intersemanal/useIntersemanalSecaoParams';
import { useGetIntersemanalChuvaObservadaQuery } from 'services/api/products/relatorios';

export default function ChuvaObservada() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useIntersemanalSecaoParams();

  const { data, isLoading } = useGetIntersemanalChuvaObservadaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <ChuvaLayout
      data={data}
      canEdit={userIsAdmin}
      variant="intersemanal"
      galeriaTitulo="CHUVA OBSERVADA"
    />
  );
}
